import React, { useMemo, useState } from "react";

const ISSUE_TYPES = ["damage", "warning_light", "tire", "mechanical", "cleaning", "fuel", "accident", "other"];
const SEVERITIES = ["low", "medium", "high", "critical"];

export function DriverIssueReport({ initialVehicleId = "", onSubmit, busy, successMessage }) {
  const [issueType, setIssueType] = useState("damage");
  const [severity, setSeverity] = useState("medium");
  const [description, setDescription] = useState("");
  const [files, setFiles] = useState([]);
  const fileLabel = useMemo(() => files.length ? `${files.length} file${files.length > 1 ? "s" : ""} selected` : "Take photo / Upload photo", [files]);

  const submit = async (e) => {
    e.preventDefault();
    await onSubmit?.({ issue_type: issueType, severity, description, files, vehicle_id: initialVehicleId });
  };

  return (
    <form onSubmit={submit} className="space-y-5" data-testid="driver-issue-report-form">
      <div className="rounded-2xl border border-slate-200 bg-white p-5 space-y-5">
        <div>
          <p className="text-xs font-bold uppercase tracking-[0.18em] text-sky-700">Report vehicle issue</p>
          <h1 className="mt-2 font-heading text-3xl font-semibold tracking-tight text-slate-900">Issue report</h1>
        </div>

        <div>
          <p className="text-xs font-semibold uppercase tracking-[0.18em] text-slate-500">Issue type</p>
          <div className="mt-2 grid grid-cols-2 gap-2">
            {ISSUE_TYPES.map((item) => (
              <button key={item} type="button" onClick={() => setIssueType(item)} data-testid={`driver-issue-type-${item}`} className={`rounded-xl px-3 py-3 text-sm font-semibold ${issueType === item ? "bg-slate-900 text-white" : "border border-slate-300 text-slate-700"}`}>
                {item.replace(/_/g, " ")}
              </button>
            ))}
          </div>
        </div>

        <div>
          <p className="text-xs font-semibold uppercase tracking-[0.18em] text-slate-500">Severity</p>
          <div className="mt-2 grid grid-cols-2 gap-2">
            {SEVERITIES.map((item) => (
              <button key={item} type="button" onClick={() => setSeverity(item)} data-testid={`driver-issue-severity-${item}`} className={`rounded-xl px-3 py-3 text-sm font-semibold ${severity === item ? "bg-red-600 text-white" : "border border-slate-300 text-slate-700"}`}>
                {item}
              </button>
            ))}
          </div>
        </div>

        <label className="block">
          <span className="text-xs font-semibold uppercase tracking-[0.18em] text-slate-500">Description</span>
          <textarea rows={4} data-testid="driver-issue-description" value={description} onChange={(e) => setDescription(e.target.value)} className="mt-2 w-full rounded-xl border border-slate-300 px-3 py-3 text-sm outline-none focus:border-slate-900" />
        </label>

        <label className="block">
          <input type="file" accept="image/*" capture="environment" multiple className="hidden" data-testid="driver-issue-file-input" onChange={(e) => setFiles(Array.from(e.target.files || []))} />
          <span className="inline-flex w-full items-center justify-center rounded-2xl border border-slate-300 px-4 py-4 text-sm font-semibold text-slate-700">{fileLabel}</span>
        </label>

        <button type="submit" disabled={busy} data-testid="driver-issue-submit" className="w-full rounded-2xl bg-slate-900 px-5 py-4 text-sm font-semibold text-white disabled:opacity-50">
          {busy ? "Submitting…" : "Report vehicle issue"}
        </button>

        {successMessage ? <p className="text-sm font-semibold text-emerald-700">Vehicle issue reported to admin.</p> : null}
      </div>
    </form>
  );
}